export class TypeDemande {
    id: number;
    libelle: string
}
